// EN ALGUN MOMENTO MIRAR DE PASAR A ANGULAR
window.Vlitejs.registerProvider('vimeo', window.VlitejsVimeo);
window.Vlitejs.registerProvider('youtube', window.VlitejsYoutube);

document.querySelector('.backdrop').addEventListener('click', ()=>{
    document.querySelectorAll('.collapse-header').forEach(collapseH => {
        if (collapseH.classList.contains('show')) {
            const collapseHInstance = bootstrap.Collapse.getInstance(collapseH);
            collapseHInstance.hide();
        }
    });

    document.querySelectorAll('.collapse-subheader').forEach(collapse => {
        if (collapse.classList.contains('show')) {
            const collapseInstance = bootstrap.Collapse.getInstance(collapse);
            collapseInstance.hide();
        }
    });
})


document.querySelectorAll('.collapse-header button.nav-link').forEach(btn => {
    btn.addEventListener('click', ()=>{
        if ( window.matchMedia('(min-width: 1280px)').matches) { 
              document.querySelectorAll('.collapse-subheader').forEach(collapse => {
                if(btn.nextElementSibling.id !== collapse.id) {
                    if (collapse.classList.contains('show')) {
                        new bootstrap.Collapse(collapse, {
                            toggle: false
                        }).hide();
                    }
                }
            })
        }
        document.querySelector('.collapse-header').style.overflow = 'hidden'
    })
})
document.querySelectorAll('.collapse-header .btn-back').forEach(btn => {
    btn.addEventListener('click', ()=>{
        
        setTimeout(() => {
            document.querySelector('.collapse-header').style.overflow = 'auto'
        }, 300);
    })
})
// FUNCION MOVIL MENU

function btnMenu() {
    const collapseH = document.getElementById('collapseHeader');
    collapseH.addEventListener('show.bs.collapse', function () {
        document.body.classList.add('open-menu');
    });
    collapseH.addEventListener('hidden.bs.collapse', function () {
        if ( window.matchMedia('(min-width: 1280px)').matches) { 
            document.querySelectorAll('.collapse-subheader').forEach(collapse => {
            })
            // console.log(allClosed)
            setTimeout(() => {
                const allClosed = Array.from(document.querySelectorAll('.collapse-subheader')).every(collapse => !collapse.classList.contains('show'));
                if (allClosed) {
                    document.body.classList.remove('open-menu');
                }
            }, 100);

        } else {
            if (document.querySelector('.btn-menu-mov').classList.contains('collapsed')){
                document.querySelectorAll('.collapse-subheader').forEach(collapse => {
                    if (collapse.classList.contains('show')) {
                        new bootstrap.Collapse(collapse, {
                            toggle: false
                        }).hide();
                    }
                })
                document.body.classList.remove('open-menu');
                document.body.classList.remove('open-submenu');
            } 
        }
    });
}
function handleResize() {
    const collapseElement = document.querySelectorAll('footer .collapse');
    const toggleButton = document.querySelectorAll('footer .btn-drop');
    const screenWidth = window.innerWidth;

    if (screenWidth >= 900) {
        collapseElement.forEach(collapse =>{
            $(collapse).collapse('show')
        })
        toggleButton.forEach(btn =>{
            btn.disabled = true;
        })
    } else {
        collapseElement.forEach(collapse =>{
            $(collapse).collapse('hide')
        })
        toggleButton.forEach(btn =>{
            btn.disabled = false;
        })
    }
}

window.addEventListener("load", () => {
    btnMenu();
    // menuDesk();
        $('#modalProfesional').modal('show');
    // if(openMenu) {
    //     document.addEventListener('click', handleClickOutside); 
    //     document.addEventListener('touchstart', handleClickOutside); // Add touchstart event listener
    // }
    handleResize();
    if(document.querySelector('.video-js-only')) {
        document.querySelectorAll('.video-js-only .video').forEach(video => {
            let provider = null;
            let poster = null;
            if(video.dataset.poster) {
                poster = video.dataset.poster
            }
            let options = {
                controls: true,
                volume: true,
                fullscreen: true,
                loop: false,
                muted: false,
                playPause: true,
                progressBar: true,
                time: true,
                bigPlay: true,
                poster: poster
            };
         
    
            if(video.dataset.youtubeId) {
                provider = "youtube";
            } else if(video.dataset.vimeoId) {
                provider = "vimeo";
            }
    
            let vliteConfig = {
                options: options,
            };
    
            if (provider) {
                vliteConfig.provider = provider;
            }
           const pVideo =  new window.Vlitejs(video, vliteConfig)

        })
    }
    setTimeout(() => {
        var myModal = new bootstrap.Modal(document.getElementById('modalVeterinario'));
        myModal.show();
    }, 400);
    
    
});

window.addEventListener("resize", () => {
    // btnMenu();
    // menuDesk();
    handleResize();
    // if(openMenu) {
    //     document.addEventListener('click', handleClickOutside); 
    //     document.addEventListener('touchstart', handleClickOutside); // Add touchstart event listener
    // }
    // if (window.matchMedia("(max-width: 1280px)").matches) {
       

    //     if (!document.querySelector('.collapse-header').classList.contains('show')) {
    //         document.body.classList.remove('no-scroll');
    //     }
    // } else {
    //     if (document.body.classList.contains('no-scroll')) {
    //         document.body.classList.remove('no-scroll');
    //     }
    //     if (document.querySelector('.collapse-header').classList.contains('show')) {
    //         document.querySelector('.collapse-header').classList.remove('show');
    //     }
    //     if (document.querySelector('.collapse-subheader').classList.contains('show')) {
    //         document.querySelector('.collapse-subheader').classList.remove('show');
    //     }
    // }
});



if (document.querySelector('.btn-show')) {
    document.querySelector('.btn-show').addEventListener('click', function () {
        if(document.querySelector('.contact-mov')){
            this.closest('.contact-mov').classList.toggle('show-hide')
        } else {
            this.closest('.c-fixed-item').classList.toggle('show-hide')

        }
    })
}

if(document.querySelector('.c-fixed-item')) {
    window.addEventListener('scroll', function() {
        const stickyElement = document.querySelector('.c-fixed-item');
        if (window.scrollY > 100) {
            stickyElement.classList.add('fix-to-top');
        } else {
            stickyElement.classList.remove('fix-to-top');
        }
    });
}


// FUNCTION LIST DISTRIBUIDORES

if(document.querySelector('.btn-toggle-list')) {
    document.querySelector('.btn-toggle-list').addEventListener('click', ()=> {
        document.querySelector('.lista-distribuidores').classList.toggle('hide')
        document.querySelector('.btn-toggle-list').classList.toggle('rotate')
    })
}


// AJUSTAR SCALE IMG SINGLE PRODUCT SCROLL
if(document.querySelector('.fixed-product')) {
    const fixedProduct = document.querySelector('.fixed-product');

    function verificarAlturaYScroll() {
        const alturaVentana = window.innerHeight;

        if (fixedProduct.offsetHeight > alturaVentana) {
            fixedProduct.classList.add('small-img')
        } 
    }
    
    verificarAlturaYScroll();
    window.addEventListener('scroll', verificarAlturaYScroll);
}
window.addEventListener('scroll', function () {
    resizeHeader()
})
var scrollPos = 0;
const scrollThreshold = 100;
var maxTranslateY = -41; 
var maxTranslateyMov= -100; 
function resizeHeader() {
    var maxScroll = document.querySelector('.c-header').offsetHeight; 
    var translateY = (window.scrollY / maxScroll) * maxTranslateY;
    if(window.matchMedia('(min-width: 1280px)').matches) {
        if (window.scrollY > scrollThreshold) {
            if ((document.body.getBoundingClientRect()).top < scrollPos) {
                document.querySelector('.c-header').classList.add('fix-to-top');
                if (window.scrollY <= maxScroll) {
                    var translateY = (window.scrollY / maxScroll) * maxTranslateY;
                    document.querySelector('.c-header').style.transform = 'translateY(' + translateY + '%)';
                } else {
                    document.querySelector('.c-header').style.transform = 'translateY(' + maxTranslateY + '%)';
                }
            } 
        }  else {
            document.querySelector('.c-header').style.transform = 'translateY(0%)';
            document.querySelector('.c-header').classList.remove('fix-to-top');
        }
    } else if(window.matchMedia('(min-width: 900px)').matches) {
        document.querySelector('.c-header').style.transform = 'translateY(0%)';
    } else {
        if (window.scrollY > scrollThreshold) {
            if ((document.body.getBoundingClientRect()).top > scrollPos) {
                document.querySelector('.c-header').style.transform = 'translateY(0%)';
            } else {
                document.querySelector('.c-header').style.transform = 'translateY(' + maxTranslateyMov + '%)';
            } 
        }  else {
            document.querySelector('.c-header').style.transform = 'translateY(0%)';
        }
    }
    scrollPos = (document.body.getBoundingClientRect()).top;
}
